export default __webpack_public_path__ + "static/require-upfront-payment-66a8147bf7d326b4dad62cbc55555616.jpg";